import React from 'react'

import './styles.css'

interface Props {
  loading?: boolean
}

export const Loading = ({ loading }: Props) => {
  /* TEMPLATE */
  if (!loading) return null
  return (
    <div className='spinner-container'>
      <div className='lds-spinner'>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  )
}
